<div *ngIf="showSplash" class="loading">
  <div class="wait">
    <div #spinner class="loader">
    </div>
  </div>
</div>
